import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Components } from '../shared/components/components';
import { Funcoes } from '../funcoes';
import { UsuariosCargosNomesService } from './usuarios-cargos-nomes.service';
import { UsuariosCargosNomesModel } from './usuarios-cargos-nomes.model';
import { TranslateService } from '@ngx-translate/core';
import { Global } from '../global';
import { LoginService } from '../login/login.service';

declare let swal: any;

@Component({
  selector: 'app-usuarios-cargos-nomes',
  templateUrl: './usuarios-cargos-nomes.component.html'
})
export class UsuariosCargosNomesComponent extends Components implements OnInit {

  listagem: UsuariosCargosNomesModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false, "adicionar": false, "deletar": false };

  constructor(
    public translate: TranslateService,
    public router: Router,
    private service: UsuariosCargosNomesService,
    public global: Global,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();
    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'usuarios') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
          this.privilegioUsuario.adicionar = data.privilegios[i].adicionar;
          this.privilegioUsuario.deletar = data.privilegios[i].deletar;
        }
      }
    });
  }

  ngOnInit() {
    this.getPage(1);
  }

  getPage(pagina: number) {
    this.carregandoTabela = true;
    this.paginaAtual = pagina;

    this.service.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(json => {
        this.listagem = json.Payload.data;
        this.totalItens = json.Payload.total;
        this.carregandoTabela = false;
      }, error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(item: UsuariosCargosNomesModel) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarCargo') + item.nome_pt + '?',
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
    function() {
      self.service.apagar(item.id).subscribe(json => {
        self.func.showSucesso(self.func.traduzir('back.removidoComSucesso'));
        self.getPage(self.paginaAtual);
      }, error => {
        self.func.showErro(error.json());
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos-nomes/usuarios-cargos-nomes.component.ts